export class Consulta {
    Relativo:any;
    Axis:any;
    Posicion:any;
    Predicado:any;
    Secuencia:any;

    constructor(Relativo:any, Axis:any, Posicion:any, Predicado:any, Secuencia:any){
        this.Relativo = Relativo;
        this.Axis = Axis;
        this.Posicion = Posicion;
        this.Predicado = Predicado;
        this.Secuencia = Secuencia;
    }
}